export default __webpack_public_path__ + "static/media/Enter-The-Grid.e85ea318.woff";